"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var ExtendableError_1 = (0, tslib_1.__importDefault)(require("./ExtendableError"));
var createErrorMessage = function (name, resolutionStack, message) {
    resolutionStack = resolutionStack.slice();
    resolutionStack.push(name);
    var resolutionPathString = resolutionStack.join(' -> ');
    var msg = "Could not resolve '".concat(name, "'.");
    if (message) {
        msg += " ".concat(message, " \n\n Resolution path: ").concat(resolutionPathString);
    }
    return msg;
};
var ResolutionError = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ResolutionError, _super);
    function ResolutionError(name, resolutionStack, message) {
        return _super.call(this, createErrorMessage(name, resolutionStack, message)) || this;
    }
    return ResolutionError;
}(ExtendableError_1.default));
exports.default = ResolutionError;
//# sourceMappingURL=ResolutionError.js.map